import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import api from '../utils/api';

const WishlistContext = createContext(null);

export const WishlistProvider = ({ children }) => {
  const { user } = useAuth();
  const [wishlist, setWishlist] = useState([]);

  useEffect(() => {
    if (user) {
      api.get('/wishlist').then(res => setWishlist(res.data)).catch(() => {});
    } else {
      const saved = localStorage.getItem('wishlist');
      if (saved) setWishlist(JSON.parse(saved));
    }
  }, [user]);

  useEffect(() => {
    if (!user) {
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
    }
  }, [wishlist, user]);

  const addToWishlist = async (product) => {
    if (wishlist.find(w => w.product_id === product.id)) return;
    const item = {
      product_id: product.id,
      product_name: product.name,
      product_image: product.images?.[0] || '',
      price: product.sale_price || product.price
    };
    if (user) {
      try {
        await api.post('/wishlist', { product_id: product.id });
      } catch (e) {}
    }
    setWishlist(prev => [...prev, item]);
  };

  const removeFromWishlist = async (productId) => {
    if (user) {
      try {
        await api.delete(`/wishlist/${productId}`);
      } catch (e) {}
    }
    setWishlist(prev => prev.filter(w => w.product_id !== productId));
  };

  const isInWishlist = (productId) => wishlist.some(w => w.product_id === productId);

  return (
    <WishlistContext.Provider value={{ wishlist, addToWishlist, removeFromWishlist, isInWishlist, wishlistCount: wishlist.length }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
